import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import * as r from "../../../../constants/routes";
import * as a from "../../../../constants/api";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import useFetch from "../../../../hooks/useFetch";
import Spinner from "../../../../components/Spinner";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import { useTranslation } from "react-i18next";
import ListAdmins from "../../../../components/Lists/ListAdmins";
import * as h from "../../../../helpers";

export default function List() {
  const history = useNavigate();
  const { t } = useTranslation();
  const cSession = useContext(SessionContext);

  const [admins, isLoadingAdmins, errorAdmins, fetchAdmins]: any = useFetch({
    autoInit: false,
  });

  const { company_uid } = cSession ?? {};
  const { sub, is_manager } = cSession.admin ?? {};

  useEffect(() => {
    if (sub) fetchAdmins({ url: a.API_PRO_ALL });
  }, [fetchAdmins, sub]);

  let _content = null;
  const hasUsers = admins && admins.length > 0;
  if (isLoadingAdmins) {
    _content = <Spinner center />;
  } else if (errorAdmins) {
    // TODO IMG Error FETCH
  } else if (hasUsers) {
    _content = (
      <>
        <ListAdmins
          admins={admins}
          showToggleStatus
          showTogglePermissions
          companyUid={company_uid}
          amIManager={h.isTrueFromPythonBoolean(is_manager)}
          mySub={sub ?? ""}
        />
      </>
    );
  } else if (admins && admins.length === 0) {
    _content = (
      <FriendlyInfo text={t("global.you_does_not_have_users_added")}>
        <RoundButton
          small
          center
          text={t("global.add_admins")}
          title={t("global.add_admins")}
          onClick={() => history(r.R_A_PRO_ADD)}
        />
      </FriendlyInfo>
    );
  }

  return (
    <>
      <PageHeader
        title={t("global.admins_and_managers")}
        subtitle={t("global.list_admins_and_managers_on_sys")}
        btnText={is_manager ? t("global.add_admins") : null}
        btnClick={is_manager ? () => history(r.R_A_PRO_ADD) : null}
      />
      <PageMain>{_content}</PageMain>
    </>
  );
}
